import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { SubscriberRecord } from '../../Common/ConsumerModels/SubscriberRecord';

export function useGetSubscriber(subscriberId: string) {
  const [subscriberRecord, setSubscriberRecord] = useState<SubscriberRecord>(null);
  const [isSubscriberRecordLoading, setIsSubscriberRecordLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);
  const [subscriberError, setSubscriberError] = useState<string|null>(null);
  useEffect(() => {
    setIsSubscriberRecordLoading(true);
    setSubscriberError(null);
    httpClient
      .get<SubscriberRecord>(`${__API_BASE_URL__}/subscriber/getSubscriber?subscriberId=${subscriberId}`, {
        resource: __CLIENT_ID__,
        headers: {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        },
      })
      .then(({ data }) => {
        setSubscriberRecord(data);
      })
      .catch((error) => {
        let errorMsg='failed to fetch consumer details';
        if(error?.data?.Error?.Message){
          errorMsg=error.data.Error.Message;
        }
        else if(error?.message){
          errorMsg=error.message;
        }
        setSubscriberError(errorMsg);
        setSubscriberRecord(null);
        })
      .finally(() => {
        setIsSubscriberRecordLoading(false);
        });
  }, [subscriberId]);

  return [subscriberRecord, isSubscriberRecordLoading, subscriberError] as const;
}
